import React from 'react';
import { Grid, GridItem, Container } from '@fiverr-private/layout_components';
import { Box } from '@fiverr-private/theme';
import DragScrollCarousel from '../DragScrollCarousel';
import { layoutContainerClass, gridClass } from './styles.ve.css';

interface GigPreviewsLayoutProps {
  children: React.ReactNode[];
}

const GigPreviewsLayout: React.FC<GigPreviewsLayoutProps> = ({ children }) => (
  <Container
    marginBottom={{
      default: '10',
      md: '16',
    }}
    className={layoutContainerClass}
  >
    <Box display={{ default: 'block', md: 'none' }}>
      <DragScrollCarousel
        gap="6"
        itemWidth={{
          default: '284px',
          sm: '398px',
        }}
        paddingSpacers
      >
        {children.map((child, index) => (
          <Container key={index}>{child}</Container>
        ))}
      </DragScrollCarousel>
    </Box>

    <Box display={{ default: 'none', md: 'block' }}>
      <Grid
        templateColumns={{
          md: '50%_50%',
          lg: '33%_33%_33%',
        }}
        columnGap="8"
        rowGap="10"
        className={gridClass}
      >
        {children.map((child, index) => (
          <GridItem key={index}>{child}</GridItem>
        ))}
      </Grid>
    </Box>
  </Container>
);

export default GigPreviewsLayout;
